var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.667 20.167a7.333 7.333 0 1 1 14.666 0H16.5a5.5 5.5 0 1 0-11 0H3.667zM11 11.917a5.498 5.498 0 0 1-5.5-5.5c0-3.04 2.461-5.5 5.5-5.5s5.5 2.46 5.5 5.5c0 3.038-2.461 5.5-5.5 5.5zm0-1.834a3.666 3.666 0 0 0 3.667-3.666A3.666 3.666 0 0 0 11 2.75a3.666 3.666 0 0 0-3.667 3.667A3.666 3.666 0 0 0 11 10.083z",
    fill: "#222",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcons);
export default __webpack_public_path__ + "static/media/user-icons.c7a6e9a61204a305422fbd3f83e81842.svg";
export { ForwardRef as ReactComponent };